/** SQL ORDER BY direction SSOT (uppercase ASC/DESC for raw SQL clauses; distinct from the lowercase SortDirection URL/state type). */

export const SQL_SORT_DIRECTION = {
	ASC: 'ASC',
	DESC: 'DESC',
} as const;

export type SqlSortDirection = (typeof SQL_SORT_DIRECTION)[keyof typeof SQL_SORT_DIRECTION];

/** The repo-wide list convention: DESC unless an EXPLICIT `false` asks for ASC, so an omitted or template-nulled `desc`
 *  keeps the seed ordering rather than silently flipping it.
 *  @runtime-derived-ssot-helper (const-leaf-pinned): `const/actions-page-query-select.ts` and
 *  `utils/database/paginated-list-binds.ts` value-bind it, and it reads the same-file {@link SQL_SORT_DIRECTION}. */
export function sqlDirectionOfDesc(desc: unknown): SqlSortDirection {
	return desc === false ? SQL_SORT_DIRECTION.ASC : SQL_SORT_DIRECTION.DESC;
}

/** The LOWERCASE direction pair -- the URL/state spelling, distinct from the uppercase SQL clause above and NOT
 *  substitutable for it (a raw `ORDER BY` clause takes the uppercase member). The `SortDirection` union
 *  (`types/primitives-status.ts`) is derived from this record, so the two spellings of one vocabulary cannot drift:
 *  the union had NO runtime home, which is why every consumer needing the value re-typed `'desc'` or hoisted its own
 *  private one-member const. */
export const SORT_DIRECTION = {
	ASC: 'asc',
	DESC: 'desc',
} as const;
